import { render, staticRenderFns } from "./english-mock-test.vue?vue&type=template&id=71bef138&scoped=true&"
import script from "./english-mock-test.vue?vue&type=script&lang=js&"
export * from "./english-mock-test.vue?vue&type=script&lang=js&"
import style0 from "./english-mock-test.vue?vue&type=style&index=0&id=71bef138&lang=scss&scoped=true&"
import style1 from "./english-mock-test.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bef138",
  null
  
)

export default component.exports